// src/api/mock/workshopData.js
export const workshopMockData = [
  {
    id: "WS-001",
    title: "Advanced Cardiology Summit",
    price: 500000,
    speaker: "Dr. Richard Han",
    speakerRole: "Cardiologist Specialist",
    quota: 500,
    startDate: "2026-05-20",
    endDate: "2026-05-22", // Multiday
    time: "08:00 - 15:00"
  },
  {
    id: "WS-002",
    title: "Digital Healthcare Transformation",
    price: 300000,
    speaker: "Budi Santoso",
    speakerRole: "IT Director",
    quota: 300,
    startDate: "2026-05-21",
    endDate: "2026-05-21", // Single day
    time: "13:00 - 17:00"
  },
    {
    id: "WS-003",
    title: "Digital Healthcare Transformation",
    price: 300000,
    speaker: "Budi Santoso",
    speakerRole: "IT Director",
    quota: 300,
    startDate: "2026-05-21",
    endDate: "2026-05-21", // Single day
    time: "13:00 - 17:00"
  },
    {
    id: "WS-004",
    title: "Digital Healthcare Transformation",
    price: 300000,
    speaker: "Budi Santoso",
    speakerRole: "IT Director",
    quota: 300,
    startDate: "2026-05-21",
    endDate: "2026-05-21", // Single day
    time: "13:00 - 17:00"
  },
      {
    id: "WS-005",
    title: "Digital Healthcare Transformation",
    price: 300000,
    speaker: "Budi Santoso",
    speakerRole: "IT Director",
    quota: 300,
    startDate: "2026-05-21",
    endDate: "2026-05-21", // Single day
    time: "13:00 - 17:00"
  },
    {
    id: "WS-006",
    title: "Digital Healthcare Transformation",
    price: 300000,
    speaker: "Budi Santoso",
    speakerRole: "IT Director",
    quota: 300,
    startDate: "2026-05-21",
    endDate: "2026-05-21", // Single day
    time: "13:00 - 17:00"
  }
];